import apiClient from '../client'

export interface MeAvailableRole {
  id: string
  code: string
  name: string
  isExternal: boolean
}

export interface MeResponse {
  userId: string
  username: string
  fullName: string
  tenantId: string
  homeTenantId: string
  isPlatform: boolean
  activeRoleId: string | null
  activeRoleCode: string | null
  roles: MeAvailableRole[]
}

export interface MePermissionsResponse {
  activeRoleId: string | null
  permissions: string[]
}

export interface MeMenuItem {
  id: string
  code: string
  label: string
  route: string | null
  icon: string | null
  order: number
  isGroup: boolean
  isComingSoon: boolean
  requiredPermissionCode: string | null
  allowed: boolean
  children: MeMenuItem[]
}

const BASE_PATH = '/me'

export const meService = {
  async get(): Promise<MeResponse> {
    return apiClient.get<MeResponse>(BASE_PATH)
  },

  async getPermissions(): Promise<MePermissionsResponse> {
    return apiClient.get<MePermissionsResponse>(`${BASE_PATH}/permissions`)
  },

  async getMenu(): Promise<MeMenuItem[]> {
    return apiClient.get<MeMenuItem[]>(`${BASE_PATH}/menu`)
  },
}
